import { FC } from "preact/compat";
import { isMac } from "~/utils";
import { IconButton } from "../IconButton";
import { HoldKbdProps } from "./interfaces";
import ZoomInIcon from "@material-design-icons/svg/outlined/zoom_in.svg";
import cn from "classnames";

const HoldKbd: FC<HoldKbdProps> = ({
    signal,
    name = "image",
    onActivate,
    className,
}) => {
    return (
        <IconButton
            flat
            className={cn("absolute left-3 top-3 z-10", className)}
            onClick={() => {
                signal.value = !signal.peek();

                if (signal.peek()) {
                    onActivate?.();
                }
            }}
            title={`Hold ${isMac() ? "⌘" : "Ctrl"} over ${name} to zoom`}
        >
            <ZoomInIcon width="20" height="20" className="fill-current" />
        </IconButton>
    );
};

export default HoldKbd;
